import { render, staticRenderFns } from "./ModalMedicalSpecialty.vue?vue&type=template&id=8a180822&scoped=true&lang=pug"
import script from "./ModalMedicalSpecialty.vue?vue&type=script&lang=js"
export * from "./ModalMedicalSpecialty.vue?vue&type=script&lang=js"
import style0 from "./ModalMedicalSpecialty.vue?vue&type=style&index=0&id=8a180822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a180822",
  null
  
)

export default component.exports